/** @prettier */
import applicationSagas from '../../common/modules/application/sagas';

import userRegistrationSagas from './userRegistration/sagas';

export const reducers = {
  // application,
};

export const sagas = [userRegistrationSagas, applicationSagas];
